import WysiwygEditor from 'components/atoms/WysiwygEditor';
import { ActionType } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/action';
import { HubAuthoringDispatchContext } from 'pages/_AdminAuthoringPages/AdminHubAuthoring/reducer';
import { useContext } from 'react';
import { HubTextSection } from 'utils/gloo-types';

interface HubAuthoringTextFormProps {
  index: number;
  section: HubTextSection;
}

const HubSectionTextForm = ({ index, section }: HubAuthoringTextFormProps) => {
  const dispatch = useContext(HubAuthoringDispatchContext);

  return (
    <WysiwygEditor
      className="mb-6"
      height={400}
      titleText="Content"
      subtitleText="(Max 400 Characters)"
      resources={undefined}
      value={section.text}
      onChange={(value) => {
        return dispatch({
          type: ActionType.setSectionText,
          payload: {
            text: value,
            index,
          },
        });
      }}
    />
  );
};
export default HubSectionTextForm;
